module.exports = __webpack_public_path__ + "static/media/fidelity-logo.3f01c996.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/fidelity-logo.png
// module id = 7351
// module chunks = 4